module.exports = __webpack_public_path__ + "static/media/s-4-480w.80f33fae.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Projects/DM/assets/s-4-480w.png
// module id = 173
// module chunks = 0